// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialShare-module--container--qox_4"};